// extracted by mini-css-extract-plugin
export default {"wave":"wave_HFNZ8","parallax":"parallax_qTtNU","move-forever":"move-forever_VTPSQ"};